import { Component, OnInit, ViewChild, Inject, Renderer2 } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { NgForm } from '@angular/forms'
import { Router } from '@angular/router'
import { User } from '../../models/User'
import { AuthenticationService } from '../../services/authentication.service'
import { NotificationService } from '../../services/notification.service'
import { ViewValidation } from '../../_helpers/ViewValidation'
import { HelperService } from 'src/app/services/helper.service'
import { clearTablesConfig } from 'src/app/_helpers/LocalStorage'

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

	public isForcedLogout = true
	public userIsBlocked = true
	public userIsInactive = true
	public limitConnectionReached = true
	public missingCredentials = true
	public modalClosed = false
	public modalMessage = ''

	public ViewValidation: ViewValidation = new ViewValidation()
	public user: User

	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		public notificationService: NotificationService,
		private renderer: Renderer2,
		private helperService: HelperService,
	 @Inject(DOCUMENT) private document: Document
	) {}

	@ViewChild('loginForm') public loginForm: NgForm

	public ngOnInit(): void {
		this.user = new User()

		this.isForcedLogout = Boolean(localStorage.getItem('isForcedLogout'))
		this.userIsBlocked = Boolean(localStorage.getItem('userIsBlocked'))
		this.userIsInactive = Boolean(localStorage.getItem('userIsInactive'))
		this.limitConnectionReached = Boolean(localStorage.getItem('limitConnectionReached'))
		this.missingCredentials = Boolean(localStorage.getItem('missingCredentials'))

		if (this.userIsInactive) {
			this.modalMessage = 'Usuário inativado, procure um administrador!'
		} else if (this.userIsBlocked) {
			this.modalMessage = 'Usuário bloqueado!'
		} else if (this.isForcedLogout) {
			this.modalMessage = 'Sessão ativa em outro dispositivo, o seu usuário foi deslogado por outra sessão!'
		} else if(this.limitConnectionReached) {
			this.modalMessage = 'Limite de 30 conexões atingido!'
		} else if(this.missingCredentials) {
			this.modalMessage = 'Credenciais de conexão com o websocket inválidas!'
		}

		if (this.isForcedLogout || this.userIsBlocked || this.userIsInactive || this.limitConnectionReached || this.missingCredentials) {
			document.getElementById('bodyLogin').style.display = 'none'
		}

		
		// Conexões máximas só remove o navegador logado no momento do limite
		if(this.limitConnectionReached) {
			return;
		}
		
		localStorage.removeItem('access_token')
		localStorage.removeItem('currentUser')
		localStorage.removeItem('refresh_token')
		localStorage.removeItem('loggedCompany')
		localStorage.removeItem('companyId')
		localStorage.removeItem('companyName')
		localStorage.removeItem('zendesk_token')
		clearTablesConfig();
		this.logoutZendeskWidget()
	}

	public closeModal() {
		this.modalClosed = true
		this.isForcedLogout = false
		localStorage.removeItem('isForcedLogout')
		localStorage.removeItem('userIsBlocked')
		localStorage.removeItem('userIsInactive')
		localStorage.removeItem('limitConnectionReached')
		localStorage.removeItem('missingCredentials')
		document.getElementById('bodyLogin').style.display = 'block'
	}

	public async login(): Promise<void> {
		await this.authenticationService.login(this.user).toPromise()
		this.helperService.setUserIp()
		this.router.navigate(['/redirect'])
	}

	public logoutZendeskWidget() {
				const scriptZendesk: HTMLScriptElement = this.document.getElementById('ze-snippet') as HTMLScriptElement | null

				if (scriptZendesk) {
						(window as any).logoutZendesk()

			   this.renderer.removeChild(this.document.body, scriptZendesk)
				}

		  const iframe = this.document.getElementById('launcher') as HTMLIFrameElement | null

		  if (iframe) {
			const parentNode: HTMLDivElement = iframe.parentElement as HTMLDivElement
			parentNode.style.display = 'none'
		}
		}
}
